
import vars from "@exovera/narrative-tracker-variables";


// 
// View types
//
export const VIEW_TYPE_ENTITY = "entity";
export const VIEW_TYPE_CORP_RECORD = "corprecord";
export const VIEW_TYPE_RESUME = "resume";

// 
// View modes
//
export const VIEW_MODE_TABULAR = "tabular";
export const VIEW_MODE_GRAPHICAL = "graphical";

//
// Entity Types
//
export const ENTITY_TYPE_ALL = "all";
export const ENTITY_TYPE_ORG = "organization";
export const ENTITY_TYPE_PERSON = "person";
export const ENTITY_TYPE_VESSEL = "vessel";
export const ENTITY_TYPE_RESUME = "resume";
export const ENTITY_TYPE_PROJECT = "project";
export const ENTITY_TYPE_CORPORATE_RECORD = "corporate_record";

export const ENTITY_TYPE_LABEL_ALL = "All";
export const ENTITY_TYPE_LABEL_ORGS = "Orgs";
export const ENTITY_TYPE_LABEL_PEOPLE = "People";
export const ENTITY_TYPE_LABEL_VESSELS = "Vessels";
export const ENTITY_TYPE_LABEL_RESUMES = "Resumes";
export const ENTITY_TYPE_LABEL_PROJECTS = "Projects";
export const ENTITY_TYPE_LABEL_CORPORATE_RECORD = "Corp Record";

//
// Entity Export Types
//
export const ENTITY_EXPORT_TYPE_CSV = "CSV";
export const ENTITY_EXPORT_TYPE_PDF = "PDF";

//
// Common Attributes
//
export const ATTR_SOURCE_COUNTRY = "sourceCountry";
export const ATTR_INTERNAL_VERSION = "_version_";
export const ATTR_COLLECTION_GROUP = "collectionGroup";
export const ATTR_AGENT_ID = "agent_id";

//
// Entity Attributes
//
export const ATTR_ADDRESS = "address";
export const ATTR_ADDRESS_EN = "address_en";
export const ATTR_AKA = "aka"; // array
export const ATTR_AKA_EN = "aka_en"; // array
export const ATTR_CALL_SIGN = "call_sign"; // array
export const ATTR_CATEGORIES = "categories"; // array
export const ATTR_CITIZENSHIP = "citizenship";
export const ATTR_CREATION_SOURCE = "creation_source";
export const ATTR_DETAILS = "details";
export const ATTR_DOB = "date_of_birth"; // array
export const ATTR_DISSOLUTION_DATE = "dissolution_date"; // array
export const ATTR_EMAIL = "email"; // array
export const ATTR_ENTITY_TYPE = "entity_type";
export const ATTR_ENTITY_TYPE_2 = "entityType";
export const ATTR_EU_REF_NUM = "EU_ref_num"; // array
export const ATTR_FED_REGISTER_NOTICE = "fed_register_notice"; // array
export const ATTR_FAX_NUMBER = "fax_number"; // array
export const ATTR_FKA = "fka"; // array
export const ATTR_FKA_EN = "fka_en"; // array
export const ATTR_FLAG_STATE = "flag_state"; // array
export const ATTR_FORMER_FLAG_STATE = "former_flag_state"; // array
export const ATTR_GROSS_TONNAGE = "gross_tonnage"; // array 
export const ATTR_HTML_HASH = "html_hash";  
export const ATTR_ID = "id"; 
export const ATTR_IMO = "imo"; // array
export const ATTR_INN = "inn"; // array 
export const ATTR_KPP = "kpp"; // array
export const ATTR_LABEL = "label";
export const ATTR_LABEL_EN = "label_en";
export const ATTR_LAST_EDITED_TIME = "last_edited_time"; 
export const ATTR_MMSI = "mmsi"; // array
export const ATTR_NATIONALITY = "nationality"; // array
export const ATTR_NATIONAL_ID_NUMBER = "national_identity_number"; // array 
export const ATTR_OGRN = "ogrn"; // array
export const ATTR_OKPO = "okpo"; // array
export const ATTR_ORG_TYPE = "organization_type"; // array
export const ATTR_OWNER = "owner"; // array
export const ATTR_PASSPORT_NUM = "passport_num"; // array
export const ATTR_PRIMARY_COUNTRY = "primary_country"; // array
export const ATTR_POB = "place_of_birth"; // array
export const ATTR_PHONE_NUMBER = "phone_number"; // array
export const ATTR_REGISTRATION_DATE = "registration_date"; // array
export const ATTR_REGISTRATION_NUM = "registration_num"; // array
export const ATTR_SANCTIONED = "sanctioned";
export const ATTR_SANCTIONED_AUTHORITY = "sanction_authority"; // array
export const ATTR_SANCTIONED_PROGRAM = "sanction_program"; // array
export const ATTR_SANCTIONED_STATUS = "sanctioned_status";
export const ATTR_SOURCES = "sources";
export const ATTR_STATUS = "status";
export const ATTR_TAX_NUMBER = "tax_number";
export const ATTR_TITLE = "title";
export const ATTR_TRANS_FULL_TEXT = "translatedFullText";
export const ATTR_TYPE = "type";
export const ATTR_UNIFIED_SOCIAL_CREDIT_CODE = "unified_social_credit_code"; // array 
export const ATTR_UN_PERM_REF_NUM = "UN_perm_ref_num"; // array
export const ATTR_US_ENTITY_NUM = "US_entity_num"; // array
export const ATTR_VESSEL_TYPE = "vessel_type"; // array 
export const ATTR_WEBSITE = "website";
export const ATTR_YEAR_BUILT = "year_built"; // array 


//
// Resumes attribute types
//
export const ATTR_AGE = "age";
export const ATTR_AWARDS = "awards";
export const ATTR_BIRTHPLACE = "birthplace";
export const ATTR_BUSINESS_SKILLS = "business_skills";
export const ATTR_CERTIFICATE = "certificate";
export const ATTR_CURRENT_COMPANY = "current_company";
export const ATTR_CURRENT_LOCATION = "current_location";
export const ATTR_CURRENT_SALARY = "current_salary";
export const ATTR_CURRENT_STATUS = "current_status";
export const ATTR_CURRENT_POSITION = "current_position";
export const ATTR_DATE_OF_BIRTH = "date_of_birth";
export const ATTR_DEGREE = "degree";
export const ATTR_DESIRED_POSITIONS = "desired_positions";
export const ATTR_DESIRED_SALARY = "desired_salary";
export const ATTR_DETAILED_LOCATION = "detailed_location";
export const ATTR_EXPECT_LOCATION = "expect_location";
export const ATTR_ETHNIC = "ethnic";
export const ATTR_EXPERIENCE = "experience";
export const ATTR_GENDER = "gender";
export const ATTR_IT_SKILLS = "it_skills";
export const ATTR_LANGUAGE = "language";
export const ATTR_LABEL_T_PRIMARY = "label_t_primary";
export const ATTR_LAST_UPDATE_TIME = "lastupdate_time";
export const ATTR_MARITAL_STATUS = "marital_status";
export const ATTR_MAJOR = "major";
export const ATTR_NATIONAL_IDENTITY_NUMBER = "national_identity_number";
export const ATTR_NUM_WORK_EXPERIENCE = "num_work_experience";
export const ATTR_POLITICAL_STATUS = "political_status";
export const ATTR_SCHOOL_NAME = "school_name";
export const ATTR_SCHOOL_TYPE = "school_type";
export const ATTR_SELF_EVALUATION = "self_evaluation";
export const ATTR_SKILLS = "skills";
export const ATTR_WORK_START_YEAR = "work_start_year";


//
// Corp Records attribute types
//
export const ATTR_ENTERPRISE_TYPE = "enterprise_type";
export const ATTR_INDUSTRY = "industry";
export const ATTR_BUSINESS_SCOPE = "business_scope";
export const ATTR_OPERATING_PERIOD = "operating_period";
export const ATTR_OPERATION_STATUS = "operation_status";
export const ATTR_NUMBER_OF_EMPLOYEES = "number_of_employees";
export const ATTR_EMPLOYEES_AT_LOCATION = "employees_at_location";
export const ATTR_FOUNDING_YEAR = "founding_year";
export const ATTR_START_DATE = "start_date";
export const ATTR_CEO = "ceo";
export const ATTR_IND_AND_COMMERCE_NUM = "industry_and_commerce_number";
export const ATTR_ORG_GROUP_NUMBER = "organization_group_number";
export const ATTR_TAX_ID_NUMBER = "tax_id_number";
export const ATTR_DUNS_NUMBER = "d_u_n_s_number";
export const ATTR_BAIDU_ID = "baidu_id";
export const ATTR_US_STANDARD_INDUSTRIAL_CLASSIFICATIONS = "us_standard_industrial_classifications";
export const ATTR_SCALE = "scale"; 
export const ATTR_PLACE_OF_BUSINESS = "place_of_business";
export const ATTR_ADMINISTRATIVE_SUBDIVISION = "administrative_subdivision";
export const ATTR_ZIP_CODE = "zipcode";
export const ATTR_LATITUDE= "latitude";
export const ATTR_LONGITUDE= "longitude";
export const ATTR_REGISTERED_ADDRESS = "registered_address";
export const ATTR_REGISTERED_CAPITAL = "registered_capital";
export const ATTR_CONTRIBUTED_CAPITAL = "contributed_capital";
export const ATTR_REGISTRATION_AUTHORITY = "registration_authority"; 
export const ATTR_REGISTRY_AGENCY = "registry_agency";
export const ATTR_AUDIT_DATE = "audit_date";
export const ATTR_SHAREHOLDER = "shareholder";
export const ATTR_COMPANY_SUMMARY = "company_summary";

//
// Internal / Non-Display Entity Attributes
//
export const ATTR_ARANGO_ID = "arango_id";
export const ATTR_DATA = "data";
export const ATTR_EDGES = "edges";
export const ATTR_ENTITY = "entity";
export const ATTR_GOOGLE_TRANSLATE = "googleTranslate";
export const ATTR_LANG = "lang";
export const ATTR_ORIG_FULL_TEXT = "originalFullText";
export const ATTR_EXPORT_CSV_LINK = "csvLink";
export const ATTR_EXPORT_PDF_LINK = "pdfLink";

//
// Derived Entity Attributes
//
export const ATTR_SME_VERIFIED = "sme_verified";
export const ATTR_PLA_AFFILIATED = "pla_affiliated";
export const ATTR_CCP_AFFILIATED = "ccp_affiliated";
export const ATTR_LAST_EDITED_TIME_STR = "last_edited_time_str"; 
export const ATTR_DATE_OF_INFORMATION = "date_of_information"; 

//
// Entity Attribute Values
//
export const VAL_STATUS_APPROVED = "Approved";
export const VAL_STATUS_AWAITING_APPROVAL = "Awaiting Approval";
export const VAL_SOURCES_FILE_LINK = "fileLink";
export const VAL_SOURCES_FILENAME = "filename";
export const VAL_SOURCES_LINK = "sourceUrl";

//
// Entity Affiliation Types
//
export const AFF_TYPE_AFFILIATION = "Affiliation";
export const AFF_TYPE_BRANCH = "Branch";
export const AFF_TYPE_BOARD_MEMBER = "Board member";
export const AFF_TYPE_COLLABORATOR = "Collaborator";
export const AFF_TYPE_EMPLOYMENT = "Employment";
export const AFF_TYPE_FOUNDER = "Founder";
export const AFF_TYPE_FUNDER = "Funder";
export const AFF_TYPE_INVESTOR = "Investor";
export const AFF_TYPE_LEADER = "Leader";
export const AFF_TYPE_MANAGING_ORG = "Managing organization";
export const AFF_TYPE_MEMBER = "Member";
export const AFF_TYPE_OPERATED_BY = "Operated by";
export const AFF_TYPE_ORGANIZER = "Organizer";
export const AFF_TYPE_RESEARCH_UNIT = "Research unit";
export const AFF_TYPE_SHAREHOLDER = "Shareholder";
export const AFF_TYPE_SUBORDINATE = "Subordinate";
export const AFF_TYPE_SUPERORDINATE = "Superordinate";
export const AFF_TYPE_SUPPLIER = "Supplier";
export const AFF_TYPE_SUPPORTER = "Supporter";
export const AFF_TYPE_SUPPORTS = "Supports";
export const AFF_TYPE_VESSEL_OPERATOR = "Vessel operator";
export const AFF_TYPE_WORK_EXPERIENCE = "Work experience";
export const AFF_TYPE_EDUCATION_EXPERIENCE = "Education experience";
export const AFF_TYPE_SOCIAL_EXPERIENCE = "Social experience";
export const AFF_TYPE_PROJECT_EXPERIENCE = "Project experience";

export const ENTITY_AFFILIATION_TYPES = [
  AFF_TYPE_AFFILIATION,
  AFF_TYPE_BOARD_MEMBER,
  AFF_TYPE_BRANCH,
  AFF_TYPE_COLLABORATOR,
  AFF_TYPE_EMPLOYMENT,
  AFF_TYPE_FOUNDER,
  AFF_TYPE_FUNDER,
  AFF_TYPE_LEADER,
  AFF_TYPE_MANAGING_ORG,
  AFF_TYPE_MEMBER,
  AFF_TYPE_OPERATED_BY,   // Does not exist in Gossamer ?
  AFF_TYPE_ORGANIZER,
  AFF_TYPE_RESEARCH_UNIT,   // Does not exist in Gossamer ?
  AFF_TYPE_SHAREHOLDER,
  AFF_TYPE_SUBORDINATE,
  AFF_TYPE_SUPPLIER,
  AFF_TYPE_SUPPORTER, // Does not exist in Gossamer ?
  AFF_TYPE_SUPPORTS,
  AFF_TYPE_VESSEL_OPERATOR,
  AFF_TYPE_WORK_EXPERIENCE,
  AFF_TYPE_EDUCATION_EXPERIENCE,
  AFF_TYPE_SOCIAL_EXPERIENCE,
  AFF_TYPE_PROJECT_EXPERIENCE,
];

export const ENTITY_AFFILIATION_DESCRIPTIONS = {
  [AFF_TYPE_AFFILIATION]: "is affiliated with",
  [AFF_TYPE_BOARD_MEMBER]: "is a board member of", 
  [AFF_TYPE_BRANCH]: "is a branch of",
  [AFF_TYPE_COLLABORATOR]: "collaborates with",
  [AFF_TYPE_EMPLOYMENT]: "is employed by",                   
  [AFF_TYPE_FOUNDER]: "is a founder of",  
  [AFF_TYPE_FUNDER]: "funds",
  [AFF_TYPE_LEADER]: "is a leader of",   
  [AFF_TYPE_MANAGING_ORG]: "is a managing organization of",
  [AFF_TYPE_MEMBER]: "is a member of",     
  [AFF_TYPE_OPERATED_BY]: "is operated by",
  [AFF_TYPE_ORGANIZER]: "organizes",
  [AFF_TYPE_RESEARCH_UNIT]: "is a research unit of",
  [AFF_TYPE_SHAREHOLDER]: "has shares held by",    
  [AFF_TYPE_SUBORDINATE]: "controls",
  [AFF_TYPE_SUPPLIER]: "supplies",
  [AFF_TYPE_SUPPORTER]: "supports", 
  [AFF_TYPE_SUPPORTS]: "supports",
  [AFF_TYPE_VESSEL_OPERATOR]: "operates",
  [AFF_TYPE_WORK_EXPERIENCE]: "has work experience with",
  [AFF_TYPE_EDUCATION_EXPERIENCE]: "has educational experience with",
  [AFF_TYPE_SOCIAL_EXPERIENCE]: "has social experience with",
  [AFF_TYPE_PROJECT_EXPERIENCE]: "has project experience with",
}

//
// Edge Attributes
//

export const ATTR_EDGE_SOURCE = "source";
export const ATTR_EDGE_TARGET = "target";
export const ATTR_EDGE_ARANGO_ID = "arango_id";
export const ATTR_EDGE_DETAILS = "details";
export const ATTR_EDGE_ACTUAL_INVEST_AMOUNT = "actual_investment_amount";
export const ATTR_EDGE_CATEGORIES = "categories";
export const ATTR_EDGE_END_DATE = "end_date";
export const ATTR_EDGE_FEEDBACK = "feedback";
export const ATTR_EDGE_FORMER = "former";
export const ATTR_EDGE_JOB_TITLE = "job_title";
export const ATTR_EDGE_LABEL = "label";
export const ATTR_EDGE_LABEL_EN = "label_en";
export const ATTR_EDGE_OWNERSHIP_PERCENTAGE = "ownership_percentage";
export const ATTR_EDGE_REPORT_INVEST_AMOUNT = "reported_investment_amount";
export const ATTR_EDGE_START_DATE = "start_date";
export const ATTR_EDGE_STATUS = "status";
export const ATTR_EDGE_TITLE = "title";
export const ATTR_EDGE_TYPE = "type";
export const ATTR_EDGE_MAPPED_TYPE = "edgeType";
export const ATTR_EDGE_SOURCES = "sources";

//
// General Constants
//

export const EMPTY_IND = "-";

// Returns a boolean indicating if an attribute ID is displayed in a dedicated area 
// of the UI (false) or should be treated as an "other" attribute (true) for generic display
export const isOtherAttr = (attrId) => {
  switch (attrId) {
    case ATTR_ADMINISTRATIVE_SUBDIVISION:
    case ATTR_ADDRESS:
    case ATTR_ADDRESS_EN:
    case ATTR_AKA:
    case ATTR_AKA_EN:
    case ATTR_AUDIT_DATE:
    case ATTR_BAIDU_ID:
    case ATTR_BUSINESS_SCOPE:
    case ATTR_CALL_SIGN:
    case ATTR_CATEGORIES:
    case ATTR_CCP_AFFILIATED:
    case ATTR_CEO:
    case ATTR_CONTRIBUTED_CAPITAL:
    case ATTR_CREATION_SOURCE:
    case ATTR_CITIZENSHIP:
    case ATTR_COMPANY_SUMMARY:
    case ATTR_DETAILS:
    case ATTR_DISSOLUTION_DATE:
    case ATTR_DUNS_NUMBER:
    case ATTR_EMPLOYEES_AT_LOCATION:
    case ATTR_ENTERPRISE_TYPE:
    case ATTR_ENTITY_TYPE:
    case ATTR_ENTITY_TYPE_2:
    case ATTR_DATE_OF_INFORMATION:
    case ATTR_DOB:
    case ATTR_EMAIL:
    case ATTR_FAX_NUMBER:
    case ATTR_FKA:
    case ATTR_FKA_EN:
    case ATTR_FLAG_STATE:
    case ATTR_FORMER_FLAG_STATE:
    case ATTR_FOUNDING_YEAR:
    case ATTR_GROSS_TONNAGE:
    case ATTR_IMO:
    case ATTR_IND_AND_COMMERCE_NUM:
    case ATTR_INDUSTRY:
    case ATTR_INN:
    case ATTR_KPP:
    case ATTR_LABEL:
    case ATTR_LABEL_EN:
    case ATTR_LATITUDE:
    case ATTR_LAST_EDITED_TIME:
    case ATTR_LAST_EDITED_TIME_STR:
    case ATTR_LONGITUDE:
    case ATTR_MMSI:
    case ATTR_NATIONALITY:
    case ATTR_NATIONAL_ID_NUMBER:
    case ATTR_NUMBER_OF_EMPLOYEES:
    case ATTR_OGRN:
    case ATTR_OKPO:
    case ATTR_ORG_GROUP_NUMBER:
    case ATTR_ORG_TYPE:
    case ATTR_OWNER:
    case ATTR_OPERATING_PERIOD:
    case ATTR_OPERATION_STATUS:
    case ATTR_PASSPORT_NUM:
    case ATTR_PHONE_NUMBER:
    case ATTR_PLA_AFFILIATED:
    case ATTR_PLACE_OF_BUSINESS:
    case ATTR_PRIMARY_COUNTRY:
    case ATTR_POB:
    case ATTR_REGISTERED_ADDRESS:
    case ATTR_REGISTERED_CAPITAL:
    case ATTR_REGISTRATION_AUTHORITY:
    case ATTR_REGISTRATION_NUM:
    case ATTR_REGISTRY_AGENCY:
    case ATTR_REGISTRATION_DATE:
    case ATTR_SANCTIONED:
    case ATTR_SANCTIONED_AUTHORITY:
    case ATTR_SANCTIONED_PROGRAM:
    case ATTR_SANCTIONED_STATUS:
    case ATTR_SCALE: 
    case ATTR_SME_VERIFIED:
    case ATTR_SOURCES:
    case ATTR_SOURCE_COUNTRY:
    case ATTR_START_DATE:
    case ATTR_STATUS:
    case ATTR_TAX_NUMBER:
    case ATTR_TAX_ID_NUMBER:
    case ATTR_TITLE:
    case ATTR_UNIFIED_SOCIAL_CREDIT_CODE:
    case ATTR_US_ENTITY_NUM:
    case ATTR_US_STANDARD_INDUSTRIAL_CLASSIFICATIONS:
    case ATTR_VESSEL_TYPE:
    case ATTR_WEBSITE:
    case ATTR_YEAR_BUILT:
    case ATTR_ZIP_CODE:
    case ATTR_AGE:
    case ATTR_AWARDS:
    case ATTR_BIRTHPLACE:
    case ATTR_CERTIFICATE:
    case ATTR_COLLECTION_GROUP:
    case ATTR_CURRENT_COMPANY:
    case ATTR_CURRENT_POSITION:
    case ATTR_CURRENT_LOCATION:
    case ATTR_CURRENT_SALARY:
    case ATTR_CURRENT_STATUS:
    case ATTR_DATE_OF_BIRTH:
    case ATTR_DEGREE:
    case ATTR_DESIRED_POSITIONS:
    case ATTR_DESIRED_SALARY:
    case ATTR_DETAILED_LOCATION:
    case ATTR_ETHNIC:
    case ATTR_EXPECT_LOCATION:
    case ATTR_EXPERIENCE:
    case ATTR_GENDER:
    case ATTR_IT_SKILLS:
    case ATTR_LABEL_T_PRIMARY:
    case ATTR_LANGUAGE:
    case ATTR_LAST_UPDATE_TIME:
    case ATTR_MARITAL_STATUS:
    case ATTR_MAJOR:
    case ATTR_NATIONAL_IDENTITY_NUMBER:
    case ATTR_NUM_WORK_EXPERIENCE:
    case ATTR_POLITICAL_STATUS:
    case ATTR_SCHOOL_NAME:
    case ATTR_SCHOOL_TYPE:
    case ATTR_BUSINESS_SKILLS:
    case ATTR_SELF_EVALUATION:
    case ATTR_SKILLS:
    case ATTR_TYPE:
    case ATTR_WORK_START_YEAR:
      return false;
    default:
      return true;
  }
}

export const isDisplayAttr = (attrId) => {
  switch (attrId) {
    case ATTR_ARANGO_ID:
    case ATTR_AGENT_ID:
    case ATTR_COLLECTION_GROUP:
    case ATTR_DATA:
    case ATTR_EDGES:
    case ATTR_ENTITY:
    case ATTR_EXPORT_CSV_LINK:
    case ATTR_EXPORT_PDF_LINK:
    case ATTR_GOOGLE_TRANSLATE:
    case ATTR_HTML_HASH:
    case ATTR_ID:
    case ATTR_LANG:
    case ATTR_ORIG_FULL_TEXT:
    case ATTR_STATUS:
    case ATTR_TRANS_FULL_TEXT:
    case ATTR_TYPE:
    case ATTR_SHAREHOLDER:
    case ATTR_INTERNAL_VERSION:
      return false;
    default:
      return true;
  }
}

// Colors
export const COLORS = {
  errorTextColor: darkUI => darkUI ? "#C66173" : "#A7001E",
	exoInsightsTextColor: darkUI => darkUI ? vars.exoveraGreen : vars.exoveraDarkGreen,
  noResultsTextColor: darkUI => darkUI ? vars.sky_2 : vars.text_2,
  retryButtonColor: darkUI => darkUI ? vars.cerulean_3 : vars.cerulean_2,
  retryButtonBgColor: darkUI => darkUI ? vars.charcoal_0_9 : "#fff",
  retryButtonHoverColor: darkUI => darkUI ? vars.cerulean_2 : vars.cerulean_1,
  retryButtonBgHoverColor: darkUI => darkUI ? vars.charcoal_0_8 : vars.blueGrey_0_5,
  bgColor: darkUI => darkUI ? vars.charcoal_1 : "#ffffff",
  popoverColor: darkUI => darkUI ? vars.charcoal_0_8 : "#ffffff",
	itemLabelColor: darkUI => darkUI ? vars.sky_1 : vars.black_3,
	itemValueColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3_7,
	itemIconColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3_5,
  popoverHeaderTextColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3,
  popoverHeaderIconColor: darkUI => darkUI ? vars.sky_2 : vars.grey_2_5,
  panelBgColor: darkUI => darkUI ? "rgba(25, 32, 53, 0.8)" : "rgba(255, 255, 255, 0.8)",
  dividerColor: darkUI => darkUI ? vars.grey_4_3 : "#FBFBFB",
  tabIndColor: darkUI => darkUI ? vars.cerulean_1 : vars.cerulean_2,
  nodePingColor: darkUI => darkUI ? vars.red_1 : vars.red_1,
  tooltipBgColor: darkUI => darkUI ? vars.grey_3 : vars.blueGrey_2,
  tooltipTextColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3,
  menuDividerColor: darkUI => darkUI ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)",
  chipBgColor: darkUI => darkUI ? vars.charcoal_1 : vars.blueGrey_0_5,
}

export const PANEL_HEADER_HEIGHT = 34;
export const PANEL_PADDING = 10;
export const PANEL_SPACING = 5;
export const PANEL_BORDER = 1;

// DOM
export const SCROLL_ID = "entity-view-scroll";